import { LitElement, html, css, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { tokens } from '../styles/tokens';
import { icon } from '../icons';
import type { SarahMedecin } from '../types';
import './sarah-inscription';

@customElement('sarah-recap-medecins')
export class SarahRecapMedecins extends LitElement {
  static styles = [
    tokens,
    css`
      :host {
        display: block;
        font-family: var(--sarah-font-body);
        color: var(--sarah-text);
      }

      .recap-medecins .medecins-liste {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 16px;
      }
      @media (max-width: 719px) {
        .recap-medecins .medecins-liste { grid-template-columns: 1fr; }
      }

      .medecin {
        padding: 15px;
        border: 1px solid #eaeaea3b;
        background-color: #eaeaea3b;
        border-radius: 5px;
        height: 100%;
      }
      .medecin { filter: blur(4px); }
      .medecin p { margin: 0; }

      .medecin.medecin-pref p {
        display: flex;
        align-items: center;
        font-size: 20px;
        color: #424242;
        font-weight: 700;
      }
      .medecin.medecin-pref p.link { font-size: 16px; }
      .medecin.medecin-pref .icon { margin-right: 10px; }

      .medecin .nom {
        color: var(--sarah-bleu);
        font-weight: 800;
        font-size: 20px;
        margin: 0 0 6px;
        text-align: left;
      }
      .medecin .adresse,
      .medecin .telephone,
      .medecin .link {
        display: flex;
        align-items: center;
        gap: 6px;
        margin: 4px 0;
        font-size: 15px;
        text-align: left;
      }
      .medecin .icon {
        display: inline-flex;
        align-items: center;
        width: 18px;
        height: 18px;
        color: var(--sarah-bleu);
        flex-shrink: 0;
      }
      .medecin .icon svg { width: 100%; height: 100%; }

      @media (max-width: 719px) {
        .medecin .nom { font-size: 20px; }
        .medecin .adresse,
        .medecin .telephone { font-size: 18px; }
      }
    `,
  ];

  @property({ type: Array }) medecins: SarahMedecin[] = [];
  @property({ type: Boolean, attribute: 'is-prefecture' }) isPrefecture = false;

  private renderMedecin(m: SarahMedecin) {
    if (this.isPrefecture) {
      return html`
        <div class="medecin medecin-pref">
          <p class="adresse">
            <span class="icon">${icon.place()}</span>${m.libelle || ''}
          </p>
          ${m.lien && m.lien !== '#'
            ? html`
                <p class="link">
                  <span class="icon">${icon.openInNew()}</span>
                  <a href=${m.lien} target="_blank" rel="noopener">${m.lien}</a>
                </p>
              `
            : nothing}
        </div>
      `;
    }
    return html`
      <div class="medecin">
        <p class="nom">${m.nom || ''}</p>
        <p class="adresse">
          <span class="icon">${icon.place()}</span>${m.adresse || ''}
        </p>
        <p class="telephone">
          <span class="icon">${icon.phone()}</span>${m.contact || ''}
        </p>
      </div>
    `;
  }

  render() {
    return html`
      <div class="recap-medecins">
        <div class="medecins-liste">
          ${this.medecins.map((m) => this.renderMedecin(m))}
        </div>
        <sarah-inscription mode="recap"></sarah-inscription>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'sarah-recap-medecins': SarahRecapMedecins;
  }
}
